module.exports = __webpack_public_path__ + "img/bath.9e41bc6a.svg";